import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Avatar, Box, Typography } from '@mui/material';
import { useAppSelector } from '../../../store';
import { getAssetURl } from '../../../utils/url';

const RootStyle = styled('div')({
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: '#EE3750',
  },
});

const InfoStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  zIndex: 99,
  position: 'absolute',
  marginTop: theme.spacing(5),
  [theme.breakpoints.up('md')]: {
    right: 'auto',
    display: 'flex',
    alignItems: 'center',
    left: theme.spacing(3),
    bottom: theme.spacing(3),
  },
}));
const ProfileCover = ({ myProfile }: any) => {
  const { fullName, position } = myProfile;
  const loggedInUserInfo = useAppSelector((state) => state.auth.user);
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );

  return (
    <RootStyle>
      <InfoStyle>
        {loggedInUserInfo?.userProfileImage?.key ? (
          <Avatar
            alt={loggedInUserInfo?.userProfileImage?.fileName}
            src={getAssetURl(
              loggedInUserInfo?.userProfileImage?.key,
              assetUrl
              // ,
              // loggedInUserInfo?.userProfileImage?.fileType
            )}
            imgProps={{ crossOrigin: 'anonymous' }}
            sx={{
              objectFit: 'contain',
              '& img': { objectFit: 'contain' },
              ml: { xs: 3, sm: 3, md: 0 },
            }}
          />
        ) : (
          <Avatar
            src='/static/mock-images/avatars/avatar_default.jpg'
            alt={loggedInUserInfo?.firstName?.toUpperCase()}
          />
        )}

        <Box
          sx={{
            ml: { md: 3 },
            mt: { xs: 1, md: 0 },
            color: 'common.white',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Typography
            variant='h4'
            className='text-capital'
          >
            {fullName}
          </Typography>
          <Typography
            sx={{ opacity: 0.72 }}
            className='text-capital'
          >
            {position}
          </Typography>
        </Box>
      </InfoStyle>
    </RootStyle>
  );
};
ProfileCover.propTypes = {
  myProfile: PropTypes.object,
};
export default ProfileCover;
